import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import SmoothScroll from 'smooth-scroll';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

const scroll = new SmoothScroll('a[href*="#"]', {
	speed: 1000
});

console.log(scroll + "");

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
    document.getElementsByClassName('navbar')[0].classList.add('fixed');
  } else {
    document.getElementsByClassName('navbar')[0].classList.remove('fixed');
  }
}